var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',_vm._l((_vm.items),function(item){return _c('v-col',{key:item.id,attrs:{"cols":"12"}},[_c('cart-item',{attrs:{"item":item},on:{"save":_vm.save,"delete":_vm.remove}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }